/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementListOrderResponse } from './MemberManagementListOrderResponse';

export type MemberManagementListOrderResponseApiRespoonse = {
    data?: MemberManagementListOrderResponse;
    status?: MemberManagementListOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementListOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

